module.exports = __webpack_public_path__ + "static/img/sfclogo.1546fb35.png";